// ================== 配置 ==================
const MAX_DURATION = 3 * 60 * 1000; // 3分钟
const UPLOAD_INTERVAL = 10 * 1000; // 10秒
let events = [];
let stopped = false;
let uploadTimer = null;
let stopTimer = null;

// ================== 检查录制开关 ==================
async function checkRecordingSwitch() {
  try {
    console.log("checkRecordingSwitch");
    let devUrl = "https://dev-plat.cnabke.com";
    let testUrl = "https://test-plat.cnabke.com";
    let masterUrl = "https://plat.cnabke.com";
    let nowUrl = "";
    let url =
      "/app-ims/websiteDataTemplateSummarize/findWebsiteIsOpenUserBehaviorReplay";
    if (window.location.hostname.indexOf("dev-") !== -1) {
      nowUrl = devUrl + url;
    } else if (
      window.location.hostname.indexOf("test") !== -1 ||
      window.location.hostname.indexOf("localhost") !== -1
    ) {
      nowUrl = testUrl + url;
    } else {
      nowUrl = masterUrl + url;
    }
    const dataTemplateId = document.getElementById("dataTemplateId")
      ? document.getElementById("dataTemplateId").value
      : "6598b9fc78c75a7f6c1df2cb";
    // const dataTemplateId = "66600f517f452c4c2db52ef4"; // 测试站点
    const response = await fetch(nowUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: dataTemplateId,
      }),
    });
    const result = await response.json();
    // return result?.data?.isOpenUserBehaviorReplay === true; // 返回是否开启录制
    return (
      result && result.data && result.data.isOpenUserBehaviorReplay === true
    ); // 返回是否开启录制
  } catch (error) {
    console.error("检查录制开关失败:", error);
    return false; // 出错时默认不录制
  }
}

// ================== 录制 ==================
export async function startRecording() {
  // 判断是否 ims 打开的预览
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("imsPreview")) {
    console.log("IMS 预览模式，不进行录制");
    return;
  }

  stopped = false;
  const isRecordingEnabled = await checkRecordingSwitch();
  if (!isRecordingEnabled) {
    console.log("录制开关已关闭，不进行录制");
    return;
  }
  console.log("录制开关已开启，开始录制");
  rrweb.record({
    emit(event) {
      events.push(event);
    },
    maskAllInputs: true, // 是否显示输入内容，可按需修改
  });
  // 启动定时上传和自动结束逻辑
  startUploadTimer();
  startStopTimer();
}

// ================== 上传方法 ==================
async function uploadEvents(isFinal = false) {
  let devUrl = "https://dev-plat.cnabke.com";
  let testUrl = "https://test-plat.cnabke.com";
  let masterUrl = "https://plat.cnabke.com";
  let nowUrl = "";
  let url = "/app-ims/websiteUserPageBehavior/createUserBehaviorFile";
  if (window.location.hostname.indexOf("dev-") !== -1) {
    nowUrl = devUrl + url;
  } else if (
    window.location.hostname.indexOf("test") !== -1 ||
    window.location.hostname.indexOf("localhost") !== -1
  ) {
    nowUrl = testUrl + url;
  } else {
    nowUrl = masterUrl + url;
  }

  if (events.length === 0) return;
  const dataTemplateId = document.getElementById("dataTemplateId")
    ? document.getElementById("dataTemplateId").value
    : "6598b9fc78c75a7f6c1df2cb";
  // const dataTemplateId = "66600f517f452c4c2db52ef4"; // 测试站点
  const entityId = document.getElementById("entityId")
    ? document.getElementById("entityId").value
    : undefined;

  const params = {
    requestUuid: sessionStorage.getItem("userBehaviorLog")
      ? JSON.parse(sessionStorage.getItem("userBehaviorLog")).requestUuid
      : "",
    dataTemplateId: dataTemplateId,
    entityId: entityId,
    requester: sessionStorage.getItem("userBehaviorLog")
      ? JSON.parse(sessionStorage.getItem("userBehaviorLog")).requester
      : "",
    data: events,
    requestTime: new Date().getTime(),
  };
  const payload = JSON.stringify(params);
  fetch(nowUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: payload,
  });
  // navigator.sendBeacon(nowUrl, payload);
  // 每次上传成功后清空缓存
  events = [];
}

// ================== 定时上传 ==================
function startUploadTimer() {
  uploadTimer = setInterval(() => {
    uploadEvents(false);
  }, UPLOAD_INTERVAL);
}

// ================== 自动结束逻辑 ==================
function startStopTimer() {
  // 3分钟后自动结束
  stopTimer = setTimeout(() => {
    stopRecording();
  }, MAX_DURATION);
}

export function stopRecording() {
  console.log(stopped, "准备停止录制");
  if (stopped) return;
  console.log("停止录制");
  stopped = true;
  clearInterval(uploadTimer);
  clearTimeout(stopTimer);
  uploadEvents(true); // 上传剩余数据
}

// ================== 页面关闭/跳转时兜底 ==================
// 由 Vue 路由钩子控制，不自动监听 beforeunload
